/** Facility template grid page size (even rows on the 3-column layout). */
export const EMAIL_BUILDER_FACILITY_TEMPLATES_LIMIT = 24;
